import * as yup from 'yup';
import { DateTime } from 'luxon';
import { eSolarPanels } from 'ui-toolkit/orders/interfaces/eSolarPanels';
import { eSplitClosing } from '../../../../ui-toolkit/enums/eSplitClosing';
import { eServices } from '../../../../ui-toolkit/enums/eServices';
import { eTransactionCategory } from 'ui-toolkit/enums/eTransactionType';
import { ITransaction } from '../../../../ui-toolkit/orders/interfaces/ITransaction';
import { eLoanType } from '../../../../ui-toolkit/orders/interfaces/eLoanType';
import { ePropertyType } from '../../../../ui-toolkit/orders/interfaces/ePropertyType';
import { eOccupancyType } from '../../../../ui-toolkit/orders/interfaces/eOccupancyType';
import { IOrderInformation } from '../../../../ui-toolkit/orders/interfaces/IOrderInformation';

const transactionValidationSimple = () => ({
  estimated_property_value: yup.number().nullable(),
  estimated_closing_date: yup
    .string()
    .nullable()
    .test('estimated_closing_date', 'Enter a valid date', (value: string | null | undefined) => {
      return value === null || value === undefined || DateTime.fromISO(value).isValid;
    }),
  rate_lock_expiration: yup
    .string()
    .nullable()
    .test(
      'rate_lock_expiration',
      'Enter a valid date',
      (value: string | null | undefined) => value === null || value === undefined || DateTime.fromISO(value).isValid
    ),

  loan_number: yup.string().nullable(),
  external_party_transaction_id: yup.string().nullable(),
  loan_type: yup.mixed<eLoanType>().nullable(),
  property_type: yup.mixed<ePropertyType>().nullable(),
  occupancy_type: yup.mixed<eOccupancyType>().nullable(),
  bulk_id: yup.string().nullable(),
  order_group_category: yup.string().nullable(),
  order_group_id: yup.string().nullable(),
  relocation_employer_name: yup.string().nullable(),
  solar_panels: yup.mixed<eSolarPanels>().nullable(),
  splitClosing: yup.mixed<eSplitClosing>().required(),
  services: yup.array().of(yup.mixed<eServices>()).required().min(1),
  firstMortgagePayoffAccount: yup.string().nullable(),
  firstMortgagePayoffName: yup.string().nullable(),
});

const transactionValidationComplex = () => ({
  loan_amount: {
    [eTransactionCategory.Purchase]: yup.number().nullable(),
    [eTransactionCategory.Refinance]: yup.number().nullable().required(),
  },
  purchase_price: {
    [eTransactionCategory.Purchase]: yup.number().nullable().required(),
    [eTransactionCategory.Refinance]: yup.number().nullable(),
  },
});
export const TransactionValidationSchemaGenerator = (
  transaction_category: eTransactionCategory,
  fieldName: keyof ITransaction
) => {
  switch (fieldName) {
    case 'loan_amount':
    case 'purchase_price':
      return transactionValidationComplex()[fieldName][transaction_category];
    default:
      const returnValue = transactionValidationSimple()[fieldName];
      if (returnValue) {
        return returnValue;
      }
      throw Error('Not supported field');
  }
};

export const OrderInformationSchemaGenerator = (fieldName: keyof IOrderInformation) => {
  switch (fieldName) {
    case 'fundingDate':
      return yup
        .string()
        .nullable()
        .test(
          'closing_date',
          'Enter a valid date',
          (value: string | null | undefined) => value === null || value === undefined || DateTime.fromISO(value).isValid
        );
    default:
      throw Error('Not supported field');
  }
};
